import { gql, useQuery, QueryHookOptions } from '@apollo/client';

import type { GetUserCompanyRemittanceTapes } from './__generated__/getUserCompanyRemittanceTapes_gql';

type GetUserCompanyRemittanceTapes_user_company_remittance_tapes = NonNullable<
  NonNullable<
    NonNullable<NonNullable<GetUserCompanyRemittanceTapes>['user']>['company']
  >['remittance_tapes']
>[number];
export const GET_USER_COMPANY_REMITTANCE_TAPES = gql`
  query GetUserCompanyRemittanceTapes {
    user {
      company {
        id
        name
        remittance_tapes {
          id
          deal_id
          payment_month
          file_state
          upload_status
          file_name
          created_at
          offering_id
          seller_company_id
          buyer_company_id
        }
      }
    }
  }
`;

export type RemittanceTapeUploadRow = GetUserCompanyRemittanceTapes_user_company_remittance_tapes;

export function useGetUserCompanyRemittanceTapes(
  options?: QueryHookOptions<GetUserCompanyRemittanceTapes>,
) {
  return useQuery<GetUserCompanyRemittanceTapes>(GET_USER_COMPANY_REMITTANCE_TAPES, options);
}
